import { Component, computed, input, output } from '@angular/core';
import { QueryParamsHandling, Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NavigationParams } from '../../models/navigation/navigationParams.interface';

export type RouterNavigationParams = {
  commands: string[];
  queryParamsHandling: QueryParamsHandling;
  queryParams: Record<string, string | null> | NavigationParams;
};

@Component({
  selector: 'app-anchor-link',
  templateUrl: './anchor-link.component.html',
  styleUrls: ['./anchor-link.component.scss'],
  imports: [CommonModule, RouterModule],
  standalone: true,
})
export class AnchorLinkComponent {
  navigation = input.required<string | RouterNavigationParams>();
  disabled = input<boolean>(false);

  clicked = output();

  isHrefNavigation = computed(() => typeof this.navigation() === 'string');

  constructor(private readonly router: Router) {}

  public onClick(event: MouseEvent) {
    event.stopPropagation();

    if (this.disabled()) {
      return;
    }
    const navigation = this.navigation();
    if (typeof navigation !== 'string') {
      this.router
        .navigate(navigation.commands, {
          queryParams: navigation.queryParams,
          queryParamsHandling: navigation.queryParamsHandling,
        })
        .then()
        .catch((error) => console.error('Navigation failed', error));
    }
    this.clicked.emit();
  }

  public onEmptyAnchorClick(event: MouseEvent) {
    event.stopPropagation();
    this.clicked.emit();
  }
}
